import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Bundles from './views/Bundles.vue'
import Upgrade from './views/Upgrade.vue'
import ManageSub from './views/ManageSub.vue'
import Register from './views/Register.vue'
import Unverified from './views/Unverified.vue'
import PmtSrc from './views/PmtSrc.vue'
import Preferences from './views/Preferences.vue'
import AccSettings from './views/AccSettings.vue'
import Verified from './views/Verified.vue'
import ManageGroups from './views/ManageGroups.vue'
import p404 from './views/p404.vue'
import Discover from './views/Discover.vue'
import Info from './views/Info.vue'
import Mobile from './views/Mobile.vue'
import SB from './views/SB.vue'
import Extension from './views/Extension.vue'
import AppSharer from './views/AppSharer.vue'
import GroupDetail from './views/GroupDetail.vue'
import ProfileDelegate from './views/ProfileDelegate.vue'
import Og from './views/Og.vue'
import Connects from './views/Connects.vue'
import Profile from './views/Profile.vue'
import Forgot from './views/Forgot.vue'
import Terms from './views/Terms.vue'
import Privacy from './views/Privacy.vue'
import ManageRequest from './views/ManageRequest.vue'
import VueMeta from 'vue-meta';
import Ads from './views/Ads.vue'
import About from './views/About.vue'
import Pricing from './views/Pricing.vue'
import FAQ from './components/SettsFAQ.vue'
import Contact from './components/SettsContact.vue'
const CMS = () => import('@/views/CMS.vue');

Vue.use(Router)
Vue.use(VueMeta)

export default (() => {
  let router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {path: '/', name: 'home', component: Home},
    {path: '/bundles', name: 'bundles', meta: { secure: true }, component: Bundles},
    {path: '/preferences', name: 'preferences', meta: { secure: true }, component: Preferences},
    {path: '/accsettings/:section?/:id?', name: 'accsettings', meta: { secure: true }, component: AccSettings, props: true},
    {path: '/connects', name: 'connects', meta: { secure: true }, component: Connects},
    {path: '/upgrade', name: 'upgrade', meta: { secure: true }, component: Upgrade},
    {path: '/managesub', name: 'manageSub', meta: { secure: true }, component: ManageSub},
    {path: '/pmtSrc', name: 'pmtSrc', meta: { secure: true }, component: PmtSrc},
    {path: '/ads', name: 'ads', meta: { secure: true }, component: Ads},
    {path: '/managerequest', name: 'managerequest', meta: { secure: true }, component: ManageRequest},
    {path: '/register', name: 'register', component: Register},
    {path: '/unverified', name: 'unverified', component: Unverified},
    {path: '/verified', name: 'verified', component: Verified},
    {path: '/sb', name: 'sb', component: SB, props: true},
    {path: '/groupdetail/:id', name: 'groupdetail', component: GroupDetail, meta: { secure: true }, props: true},
    {path: '/discover/:id?', name: 'discover', component: Discover, props: true},
    {path: '/info/:section?/:id?', name: 'info', component: Info, props: true},
    {path: '/mobile', name: 'mobile', component: Mobile, meta: { secure: true }},
    {path: '/managegroups', name: 'managegroups', component: ManageGroups, meta: { secure: true }},
    {path: '/forgot', name: 'forgot', component: Forgot},
    {path: '/terms', name: 'terms', component: Terms},
    {path: '/privacy', name: 'privacy', component: Privacy},
    {path: '/profiledelegate', name: 'profiledelegate', component: ProfileDelegate, props: true},
    {path: '/profile/:id?/:cat?/:mCode?', name: 'profile', component: Profile, props: true},
    {path: '/og/:id', name: 'og', component: Og, props: true},
    {path: '/pricing', name: 'pricing', component: Pricing, props: true},
    {path: '/faq', name: 'faq', component: FAQ, props: true},
    {path: '/contact', name: 'contact', component: Contact, props: true},
    {path: '/about', name: 'about', component: About}, /* component: () => import('./views/About.vue')}, */
    {path: '/extension', name: 'extension', meta: { secure: true }, component: Extension},
    {path: '/appsharer', name: 'appsharer', meta: { secure: true }, component: AppSharer},
    {path: '/cms', name: 'cms', meta: { secure: true }, component: CMS},
    { path: '*', component: p404 },
    {path: '/p404', name: 'p404', component: p404}, 
    ]
  })

  router.beforeEach(function(to, from, next) {

    

    if(document.getElementById('AcceptUIBackground')){
      document.getElementById('AcceptUIBackground').classList.remove('show')
      document.getElementById('AcceptUIContainer').classList.remove('show')
    }

    // block first load so mounted auth rules can take effect

    if (typeof(router.app.app) == undefined) {
      return
    }

    if(router.app.app.isAuth && to.fullPath == '/' && from.path == '/'){
      router.push('/bundles?prev=1')
      //doIt = false
    }


    if(az.noSlash(to.fullPath) == '/register' && router.app.app.isAuth) {
      router.app.app.showModalOK({ message: 'If you would like to register a new account, please log out first.' })
      router.push('/')
    } else if (to.meta.secure && !router.app.app.isAuth) {
    
      router.app.app.goAfterLogin = to.fullPath
      router.app.app.showModalLogin({ message: ''})
      router.push('/');	
      //if(az.noSlash(from.fullPath) != '')			
      //router.app.$nextTick(function(){document.getElementById('routerView').classList.toggle('bgBlur')})
      
    } else if (az.noSlash(to.fullPath) == '/completereg' && router.app.app.azCognito.cuForCompleteReg == null) {
      router.push('/')
    } else if(az.noSlash(to.fullPath) == '/cms' && router.app.app.userAttrs['custom:is_admin'] == '0') {
        router.push('/p404')
    } else {
      window.scrollTo(0, 0)
      next()
    }
  })

  router.afterEach(function (to, from) {
    var self = this
    document.getElementById('miimuMenu').classList.remove('is-active');
    document.getElementById('burger').classList.remove('is-active');
    if (to.fullPath.substring(0, 2) == '/?') {
      setTimeout(function () { document.getElementById('homeLink').classList.add('router-link-active') }, 1)
    } else if (from.fullPath.substring(0, 2) == '/?') {
      setTimeout(function () { document.getElementById('homeLink').classList.remove('router-link-active') }, 1)
    }
  })

  return router
})()
